export const saveButton = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	margin: '10px auto 20px 10px',
	overflowY: 'scroll',
	flexWrap: 'wrap',
	width: '90%',
	height: '50%'
};

export const completeViewDiv = {
	display: 'flex',
	flexDirection: 'row',
	width: '100%',
	height: '90%',
	justifyContent: 'center',
	margin: 'auto',
	overflowY: 'scroll',
	flexWrap: 'wrap'
};

export const headingStyle = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	margin: 'auto auto 10px auto',
	overflowY: 'scroll',
	flexWrap: 'wrap'
};

export const onSubmitStyle = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	margin: 'auto',
	overflowY: 'scroll',
	flexWrap: 'wrap'
};

export const margin20Px = {
	margin: '20px'
};
